var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, QueryList, AfterViewInit, OnDestroy } from '@angular/core';
import { WidgetComponent } from 'src/app/shared/components/widget/widget.component';
import { Observable, Subject } from 'rxjs';
import { Select, Store, Actions } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { StoryState } from 'src/app/story/state/story.state';
import { SelectLabel, RemoveAllChapterLabels, ConvertLabels } from 'src/app/story/state/labels/story.labels.actions';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { ToolEnum } from 'src/app/engine/models/tool.enum';
import { NextView, PreviousView } from '../../state/edit.actions';
import { FormBuilder } from '@angular/forms';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { filter, takeUntil } from 'rxjs/operators';
import { EngineCameraState } from 'src/app/engine/state/camera/engine.camera.state';
import { LockCamera } from 'src/app/engine/state/camera/engine.camera.actions';
import { LabelRecipe } from 'src/app/story/models/labels/label-recipe.enum';
var EditLabelContextComponent = /** @class */ (function () {
    function EditLabelContextComponent(store, formBuilder, actions) {
        this.store = store;
        this.formBuilder = formBuilder;
        this.actions = actions;
        this.activeToolEnum = ToolEnum;
        this.labelRecipe = LabelRecipe;
        this.interactive = false;
        this.widgetSubscriptions = [];
        this.ngUnsubscribe = new Subject();
        this.labelForm = this.formBuilder.group({
            title: [''],
            description: ['']
        });
    }
    EditLabelContextComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.bindApplicationEvents();
        // scroll to selected label
        this.selectedLabel$
            .pipe(filter(function (selectedLabel) { return !!selectedLabel; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (selectedLabel) {
            setTimeout(function () { return _this.scrollLabelIntoView(selectedLabel); });
        });
    };
    EditLabelContextComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EditLabelContextComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.subscribeToOpen();
        // Label widgets are dynamically updated, so make sure to update our event subscriptions
        // First unsubscribe, in order to prevent duplicate subscriptions.
        this.labelWidgets.changes.subscribe(function () {
            _this.unsubscribeToOpen();
            _this.subscribeToOpen();
        });
    };
    EditLabelContextComponent.prototype.bindApplicationEvents = function () {
        var _this = this;
        this.selectedChapter$.pipe(filter(function (chapter) { return chapter != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (chapter) {
            _this.interactive = chapter.readyState.model;
        });
    };
    EditLabelContextComponent.prototype.unsubscribeToOpen = function () {
        this.widgetSubscriptions.forEach(function (subscription) { return subscription.unsubscribe(); });
        this.widgetSubscriptions = [];
    };
    EditLabelContextComponent.prototype.subscribeToOpen = function () {
        var _this = this;
        this.labelWidgets.forEach(function (widget) {
            var subscription = widget.opened
                .pipe(takeUntil(_this.ngUnsubscribe))
                .subscribe(function (open) {
                // Listen for widget opening, close other widgets. Accordion style.
                _this.openWidget(widget, open);
            });
            _this.widgetSubscriptions.push(subscription);
        });
    };
    EditLabelContextComponent.prototype.handleOpenWidgets = function (open) {
        this.toggleWidgets(open);
    };
    EditLabelContextComponent.prototype.handleOpened = function (opened) {
        this.store.dispatch(new SelectLabel(opened.label));
    };
    EditLabelContextComponent.prototype.handleRemoveAll = function () {
        this.store.dispatch(new RemoveAllChapterLabels(this.store.selectSnapshot(StoryChaptersState.getSelectedChapter)));
    };
    EditLabelContextComponent.prototype.handleNext = function () {
        this.store.dispatch(new NextView());
    };
    EditLabelContextComponent.prototype.handlePrevious = function () {
        this.store.dispatch(new PreviousView());
    };
    EditLabelContextComponent.prototype.handleCheckedChange = function (change) {
        this.store.dispatch(new LockCamera(change.checked));
    };
    EditLabelContextComponent.prototype.handleConvertLabels = function (type, scope) {
        this.convertLabels(type, scope);
    };
    EditLabelContextComponent.prototype.toggleWidgets = function (open) {
        this.labelWidgets.forEach(function (widget) {
            widget.open = open;
        });
    };
    EditLabelContextComponent.prototype.openWidget = function (widget, open) {
        this.toggleWidgets(false);
        widget.open = open;
    };
    EditLabelContextComponent.prototype.trackLabel = function (label) {
        return label.id;
    };
    EditLabelContextComponent.prototype.convertLabels = function (type, scope) {
        var labels = (scope === 'story') ?
            this.store.selectSnapshot(StoryLabelsState.getLabels) :
            this.store.selectSnapshot(StoryLabelsState.getChapterLabels);
        this.store.dispatch(new ConvertLabels(labels, type));
    };
    EditLabelContextComponent.prototype.scrollLabelIntoView = function (label) {
        var target = document.querySelector("[data-id=\"" + label.id + "\"]");
        var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
        if (isSmoothScrollSupported && target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    };
    __decorate([
        Select(StoryState.getStory),
        __metadata("design:type", Observable)
    ], EditLabelContextComponent.prototype, "story$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], EditLabelContextComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(StoryLabelsState.getChapterLabels),
        __metadata("design:type", Observable)
    ], EditLabelContextComponent.prototype, "labels$", void 0);
    __decorate([
        Select(StoryLabelsState.getSelectedLabel),
        __metadata("design:type", Observable)
    ], EditLabelContextComponent.prototype, "selectedLabel$", void 0);
    __decorate([
        Select(EngineState.getChapter),
        __metadata("design:type", Observable)
    ], EditLabelContextComponent.prototype, "chapter$", void 0);
    __decorate([
        Select(EngineState.getActiveTool),
        __metadata("design:type", Observable)
    ], EditLabelContextComponent.prototype, "activeTool$", void 0);
    __decorate([
        Select(EngineCameraState.getLockCamera),
        __metadata("design:type", Observable)
    ], EditLabelContextComponent.prototype, "lockCamera$", void 0);
    return EditLabelContextComponent;
}());
export { EditLabelContextComponent };
